import { Form, Table } from "react-bootstrap";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { formatMilesDecimal, integerValidate } from "@/services/Utils";

import classes from "./createReturn.module.scss";

import { ReactComponent as DeleteIcon } from "@/assets/images/desktop/closemin.svg";
import { customStyles } from "./createReturn.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

export const CreateReturnTableDetail = ({ data, setData, items }) => {
	const { option } = useParams();
	const { addToast } = useToasts();

	const handleChangeCode = (value, i) => {
		const exist = data.details.find((d) => String(d.value) === String(value.value));

		if (exist) {
			addToast("El producto ya se encuentra ingresado.", {
				appearance: "error",
			});
		} else {
			let newDetails = [...data.details];

			newDetails[i].container_content = value.container_content;
			newDetails[i].quantity = value.quantity;
			newDetails[i].quantity_return = value.quantity;
			newDetails[i].ids = value.ids;
			newDetails[i].inventory_id = value.inventory_id;
			newDetails[i].label = value.label;
			newDetails[i].product_id = value.product_id;
			newDetails[i].price = value.price;
			newDetails[i].tradename = value.tradename;
			newDetails[i].unit_measurement = value.unit_measurement;
			newDetails[i].value = value.value;
			newDetails[i].value_column = value.value_column;
			newDetails[i].name_column = value.name_column;

			setData({ ...data, details: newDetails });
		}
	};

	return (
		<Table className={classes.tableDetail}>
			<thead className={classes.tableDetailHead}>
				<tr>
					<th className={classes.headTh}>#</th>
					<th className={classes.headTh}>Código</th>
					<th className={classes.headTh}>Producto</th>
					<th className={classes.headTh}>Contenido por Envase</th>
					<th className={classes.headTh}>U.M</th>
					<th className={classes.headTh}>Precio</th>
					<th className={classes.headTh}>Cantidad</th>
					<th className={classes.headTh}>Cantidad Devolución</th>
				</tr>
			</thead>

			<tbody>
				{data &&
					data.details &&
					data.details.map((item, i) => {
						const isBulkInventory = /factura|despacho/i.test(item.inventory_id);

						return (
							<tr key={i}>
								{/* Number */}
								<td
									style={{
										width: "3%",
										textAlign: "center",
										fontSize: "12px",
										fontWeight: "bold",
									}}
								>
									{i + 1}
								</td>
								{/* Code */}
								<td
									style={{
										width: "19%",
									}}
								>
									{option === "ingresar" ? (
										<Select
											value={items && items.filter((b) => String(b.value) === String(item.value))}
											placeholder={<div></div>}
											options={items}
											onChange={(value) => handleChangeCode(value, i)}
											menuPortalTarget={document.body}
											styles={customStyles}
											components={{
												NoOptionsMessage,
											}}
											menuPlacement="auto"
										/>
									) : (
										<Form.Control className={classes.input} type="text" value={item && item.label ? item.label : ""} readOnly={true} />
									)}
								</td>
								{/* Product */}
								<td
									style={{
										width: "20%",
									}}
								>
									<Form.Control className={classes.input} type="text" value={item && item.tradename ? item.tradename : ""} readOnly={true} />
								</td>
								{/* Container */}
								<td
									style={{
										width: "15%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.container_content ? formatMilesDecimal(item.container_content) : ""}
										readOnly={true}
									/>
								</td>
								{/* U.M */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.unit_measurement ? item.unit_measurement : ""}
										readOnly={true}
									/>
								</td>
								{/* Price */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.price ? formatMilesDecimal(isBulkInventory ? item.price : item.price * item.quantity_return) : ""}
										readOnly={true}
									/>
								</td>

								{/* Quantity */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.quantity ? formatMilesDecimal(item.quantity) : ""}
										readOnly={true}
									/>
								</td>
								{/* Quantity Return */}
								<td
									style={{
										width: "10%",
									}}
								>
									<Form.Control
										className={classes.input}
										type="text"
										value={item && item.quantity_return ? item.quantity_return : item.container_quantity}
										onChange={(e) => {
											let newDetails = [...data.details];
											newDetails[i].quantity_return = e.target.value;

											setData({
												...data,
												details: newDetails,
											});
										}}
										onKeyDown={integerValidate}
										readOnly={option === "ingresar" ? false : true}
									/>
								</td>
								{/* Actions */}
								{item && (
									<td
										style={{
											width: "5%",
										}}
									>
										{option === "ingresar" && (
											<DeleteIcon
												style={{ cursor: "pointer" }}
												className={classes.buttonClose}
												onClick={() => {
													let newDetail = [...data.details];
													newDetail.splice(i, 1);
													setData({
														...data,
														details: newDetail,
													});
												}}
											/>
										)}
									</td>
								)}
							</tr>
						);
					})}
			</tbody>
		</Table>
	);
};
